export interface CommentItem {
  id: string;
  author: string;
  avatarInitial: string;
  avatarBg: string;
  date: string;
  content: string;
  likes: number;
  liked: boolean;
}

export const articleComments: Record<string, CommentItem[]> = {
  "top-star-secret-romance-exposed": [
    {
      id: "c1",
      author: "吃瓜不嫌事大",
      avatarInitial: "瓜",
      avatarBg: "bg-primary-500",
      date: "2026-06-28 22:15",
      content: "这两人我早就看出来了！去年颁奖典礼他们坐同一桌的时候眼神就不对劲，当时我还截图发朋友圈了。赶紧公开吧别藏了！",
      likes: 3280,
      liked: false,
    },
    {
      id: "c2",
      author: "娱乐圈观察员",
      avatarInitial: "观",
      avatarBg: "bg-accent-500",
      date: "2026-06-28 22:48",
      content: "圈里早就不是秘密了。据说两边经纪公司都在帮他们谈合体综艺，到时候公开就是顺理成章的事情。商业利益最大化，懂的都懂。",
      likes: 2156,
      liked: false,
    },
    {
      id: "c3",
      author: "理性追星喵",
      avatarInitial: "喵",
      avatarBg: "bg-secondary-500",
      date: "2026-06-29 00:12",
      content: "说实话不太看好这段感情。男星之前的恋情没有一个超过两年的，而且每段结束都闹得不太愉快。希望这次能打我的脸吧。",
      likes: 1488,
      liked: false,
    },
    {
      id: "c4",
      author: "深夜码字工",
      avatarInitial: "码",
      avatarBg: "bg-primary-600",
      date: "2026-06-29 01:35",
      content: "把事业和感情分开看待吧。不管人家谈不谈恋爱的，演技在就行。最近他那部新剧确实演得不错，还是多关注作品少关注私生活吧。",
      likes: 876,
      liked: false,
    },
    {
      id: "c5",
      author: "狗仔队退休人员",
      avatarInitial: "狗",
      avatarBg: "bg-accent-600",
      date: "2026-06-29 08:20",
      content: "说个业内冷知识：大多数明星恋情曝光都是自己安排好的，时间节点、曝光方式、后续应对全都有预案。纯偶然被拍到的概率其实很低。",
      likes: 4532,
      liked: false,
    },
    {
      id: "c6",
      author: "今天也在吃瓜",
      avatarInitial: "天",
      avatarBg: "bg-secondary-600",
      date: "2026-06-29 09:05",
      content: "哈哈哈哈所以女方那个「母单」人设是彻底崩了吗？她的粉丝还说她不食人间烟火呢，这不也偷偷谈恋爱嘛🤣",
      likes: 2891,
      liked: false,
    },
  ],
  "internet-celebrity-scandal-live": [
    {
      id: "c7",
      author: "互联网考古学家",
      avatarInitial: "考",
      avatarBg: "bg-primary-500",
      date: "2026-06-27 20:30",
      content: "这些黑历史截图我之前就在某个论坛看到过，当时就预言早晚要翻车。做网红的最怕就是被人考古，互联网真的有记忆。",
      likes: 1876,
      liked: false,
    },
    {
      id: "c8",
      author: "品牌方受害者",
      avatarInitial: "品",
      avatarBg: "bg-accent-500",
      date: "2026-06-27 21:15",
      content: "我之前就买过她推荐的面膜，用完全脸过敏！去评论区说还被删评拉黑。这次翻车我一点都不同情，这种网红就该被曝光。",
      likes: 5430,
      liked: false,
    },
    {
      id: "c9",
      author: "众生皆苦",
      avatarInitial: "众",
      avatarBg: "bg-secondary-500",
      date: "2026-06-27 22:40",
      content: "虽然但是，谁年轻的时候没说过几句蠢话呢？五年前她才19岁吧，那时候的三观和现在肯定不一样。给年轻人一点成长空间吧。",
      likes: 1245,
      liked: false,
    },
    {
      id: "c10",
      author: "MCN从业者",
      avatarInitial: "M",
      avatarBg: "bg-accent-600",
      date: "2026-06-28 00:55",
      content: "业内人说一句：这次明显是对家买的黑通稿。集中时间、统一话术、多平台联动，典型的竞品打压套路。不过也是她平时树敌太多了。",
      likes: 3721,
      liked: false,
    },
  ],
  "variety-show-controversy": [
    {
      id: "c11",
      author: "综艺十级学者",
      avatarInitial: "综",
      avatarBg: "bg-primary-500",
      date: "2026-06-26 18:30",
      content: "这个节目组真的是越来越没底线了。为了话题度什么都敢做，完全不顾嘉宾的感受。上期那个互揭伤疤的环节我就觉得很不舒服。",
      likes: 2134,
      liked: false,
    },
    {
      id: "c12",
      author: "镜头后的真相",
      avatarInitial: "镜",
      avatarBg: "bg-accent-500",
      date: "2026-06-26 19:45",
      content: "说个细思极恐的点：综艺里的很多冲突其实是导演组提前设计好的。嘉宾拿到的台本上面写着「可以适当调侃B的感情状况」。所以你以为在吃真瓜，其实都是演的。",
      likes: 5640,
      liked: false,
    },
    {
      id: "c13",
      author: "佛系观众一枚",
      avatarInitial: "佛",
      avatarBg: "bg-secondary-500",
      date: "2026-06-26 21:10",
      content: "这节目我从第一季追到现在，质量真的肉眼可见在下滑。以前是靠内容出圈，现在变成了靠争议出圈。下一季如果还是这样就不追了。",
      likes: 987,
      liked: false,
    },
  ],
  "actress-divorce-details": [
    {
      id: "c14",
      author: "婚姻咨询师Linda",
      avatarInitial: "L",
      avatarBg: "bg-primary-500",
      date: "2026-06-25 19:30",
      content: "从专业角度看，聚少离多确实是娱乐圈婚姻的头号杀手。但还有一个重要因素经常被忽略：明星夫妻双方各自都有庞大的团队，这些人有时候反而会成为夫妻之间的矛盾制造者。",
      likes: 3421,
      liked: false,
    },
    {
      id: "c15",
      author: "我站女方",
      avatarInitial: "站",
      avatarBg: "bg-accent-500",
      date: "2026-06-25 20:15",
      content: "当初结婚的时候就不被看好，男方比他大十二岁还带着前妻的孩子。能坚持三年已经很不容易了。姐姐值得更好的！",
      likes: 4780,
      liked: false,
    },
    {
      id: "c16",
      author: "理性看待",
      avatarInitial: "理",
      avatarBg: "bg-secondary-500",
      date: "2026-06-25 21:00",
      content: "离婚就是成年人做的正常选择，没必要站队。既然说了是和平分手，那就祝福他们各自安好吧。吃瓜也别吃得太难看。",
      likes: 2233,
      liked: false,
    },
    {
      id: "c17",
      author: "八卦经济学",
      avatarInitial: "经",
      avatarBg: "bg-secondary-600",
      date: "2026-06-25 22:30",
      content: "好奇这个数亿资产是怎么估值的。明星的资产大部分是房产和公司股权，这两样东西的估值弹性非常大，实际分割金额可能和外面传的差很多。",
      likes: 1654,
      liked: false,
    },
  ],
};

export const defaultComments: CommentItem[] = [
  {
    id: "d1",
    author: "热心吃瓜群众",
    avatarInitial: "吃",
    avatarBg: "bg-primary-500",
    date: "2026-06-29 10:00",
    content: "这篇文章写得不错，期待更多类似的深度内容~",
    likes: 156,
    liked: false,
  },
  {
    id: "d2",
    author: "深夜来访",
    avatarInitial: "夜",
    avatarBg: "bg-accent-500",
    date: "2026-06-29 02:30",
    content: "大半夜刷到这篇文章，一口气看完，学到了不少东西。收藏了！",
    likes: 89,
    liked: false,
  },
];